import React, { useEffect, useState } from 'react';
import { isStoryExclusive } from '../../../../../helpers/story-helpers';
import { getStorySlug } from '../../../../../helpers/utils';
import { BQLink } from '../../../../atoms/bqlink';
import {
  ArrowRightIcon,
  FourStarIcon,
  StarCircleOutlineIcon,
} from '../../../../atoms/material-icons';
import EmptyState from '../empty-state';
import './stock-exclusives.m.css';

const StockExclusives = (props) => {
  const widgetParam = props?.widget ? '?view=apps' : '';
  const [exclusives, setExclusives] = useState([]);
  const [initialLoading, setInitialLoading] = useState(true);

  const getExclusives = async () => {
    const response = await fetch('/api/v1/collections/bq-blue-exclusive');
    const data = await response.json();

    setExclusives(data.items);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      getExclusives();
    }, 30000);
    return () => clearInterval(interval);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="main-stock-container">
      <div styleName="header-title-container">
        <StarCircleOutlineIcon size={'26px'} color={'#d01e51'} />
        <h2 styleName="list-header-title">EXCLUSIVE NEWS</h2>
      </div>
      {exclusives?.length === 0 ? (
        <div styleName="no-data-container-ext">
          <div styleName="no-data-container-int">
            <EmptyState subTextMessage={'for this stock at the moment'} />
          </div>
        </div>
      ) : (
        <>
          <div styleName="research-content">
            <div styleName="headline-container">
              {exclusives.slice(0, 7).map((report, index) => (
                <BQLink href={getStorySlug(report?.story)} styleName="report-content" key={index}>
                  <p styleName="item-headline">
                    {report?.story?.headline}
                    {isStoryExclusive(report?.story) && (
                      <span className="exclusive-icon">
                        <FourStarIcon color="#CE9445" size="16px" />
                      </span>
                    )}
                  </p>
                </BQLink>
              ))}
            </div>
          </div>
          <a
            styleName="show-all-reports"
            href={`/exclusive${widgetParam}`}
            target="_blank"
            rel="noreferrer"
          >
            Read More <ArrowRightIcon color={'#d01e51'} styleName="tab-icon" />
          </a>
        </>
      )}
    </div>
  );
};

export default StockExclusives;
